import React, { useContext, useEffect, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

/* packages */
import { Inputs, Buttons, Invalid } from '../../lib-atomic';
import { FormHook, LocalStorage } from '../../lib-atomic-functions';
import { FetchContextApi } from '../../lib-atomic-functions';
/* packages */

/* stores */
import { Report19, Report20 } from '../../app-module-reporting-container/stores';
/* stores */

import CONFIG from '../config';

/* CONSTANTS */
const LANDINGGRAPHICS = CONFIG.setup.assets.landing.default;
const REPORT20 = CONFIG.application.report.api.endpoints.report20;
const REPORT20OBJECTS = CONFIG.application.report.api.objects;
const REPORT20CONFIG = {
  url: REPORT20.url,
  method: REPORT20.method,
  headers: REPORT20.headers,
  responseType: 'json'
}
/* CONSTANTS */

const index = observer((props) => {

  const { token } = LocalStorage.getLS().login;

  /* state */
  REPORT20CONFIG.headers = { ...REPORT20CONFIG.headers, Authorization: token }
  const [ report20Context, report20Method ] = FetchContextApi(REPORT20CONFIG, Report20);
  /* state */

  const handleDownload = async () => {
    const filename = new Date().toLocaleString();
    const query = Object.keys(values).map(key => key + '=' + values[key]).join('&');
    await report20Method({query});

    // no report data
    if (!report20Context.status && !report20Context.data) {
      props.history.push("/reporting/l/no-available-data");
    } else {
      props.history.push({ pathname: "/reporting/l/download-pdf/20", startDate:values.startDate, endDate:values.endDate });
    }
  }

  const handleCancel = async () => {
    props.history.push("/reporting");
  }

  const {
    values,
    onChange,
    onPick,
    onSubmit,
    error,
  } = FormHook.useFormHook(handleDownload, REPORT20OBJECTS);

  /* data props */
  const formatDate = { formatDisplay: "dd/MM/yyyy", formatProcess: "YYYY-MM-DD" }
  const startDate = { ...REPORT20OBJECTS.startDate, ...formatDate, error: error.startDate, value: values.startDate, onPick };
  const endDate = { ...REPORT20OBJECTS.endDate, ...formatDate, error: error.endDate, value: values.endDate, onPick };
  const submitButton = { size: "small" }
  const cancelButton = { size: "small", onClick: handleCancel }
  /* data props */

  return <form onSubmit={onSubmit} noValidate>
    {
      /*
      accountLoginContext.data.invalidToken &&
        <Fragment>
        <Invalid {...failLogin} />
        <br/>
        </Fragment>
      */
    }
    <Inputs.Date {...startDate} />
    <Inputs.Date {...endDate} />
    <br/>
    <br/>
    <Buttons.Normal {...submitButton}>Search</Buttons.Normal>
    <Buttons.Text {...cancelButton}>Cancel</Buttons.Text>
  </form>

});

export default index;
